/**
 * Process slider
 *
 * - Initialize process slider
 *
 */
;(function (pyatt, $, window, document, undefined) {

    pyatt.processSlider = {

        init : function() {

            // $('#team-grid li.pyatt_team img').on('touchstart', Foundation.utils.throttle(function() {
            //     $(this).addClass('grayscale-off');
            // }, 300));

            // $('#team-grid li.pyatt_team img').on('touchend', Foundation.utils.throttle(function() {
            //     $(this).removeClass('grayscale-off');
            // }, 300));


            //set main element vars
            var $processSlider = $("#process-slider");
            $main = $("#banner-gallery");

            //init main carousel slider
            $processSlider.owlCarousel({
                navigation: false,
                singleItem: true,
                transitionStyle: "fade",
                navigation: true,
                pagination: false,
                navigationText: ["<span class='dashicons dashicons-arrow-left-alt2'></span>","<span class='dashicons dashicons-arrow-right-alt2'></span>"],
                addClassActive: true,
                autoHeight: true,
                autoPlay : true,
                stopOnHover: true
            });

            //init main carousel slider
            $main.owlCarousel({
                singleItem: true,
                slideSpeed: 1000,
                navigation: true,
                navigationText: ["<span class='dashicons dashicons-arrow-left-alt2'></span>","<span class='dashicons dashicons-arrow-right-alt2'></span>"],
                pagination: false,
                responsiveRefreshRate: 200,
                autoPlay: false,
                addClassActive: true,
                autoHeight: true,
                //autoWidth: true,
                //Lazy load
                lazyLoad: true,
                afterInit : function(elem){
                    $container = elem.closest('.gallery-container');
                    if ( $container.find('.owl-controls').is(':visible') ) {
                        $container.addClass('has-slides');
                    }
                },
                lazyFollow: true,
                lazyEffect: "fade",
            });

            

        }

    };

}(window.pyatt = window.pyatt || {}, jQuery, window, window.document));
